export default __webpack_public_path__ + "static/media/hotel.b2270606.png";